<!--
 * @Author: your name
 * @Date: 2022-03-10 13:24:49
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-17 16:03:47
 * @Description: file content
-->
<!--
- 抽奖条件需登陆
抽奖动画
抽奖结果需根据抽奖类型（按时间则需要达到截止时间即可开奖/按人数则第一条件按人数达到人数即开奖 诺达不到人数根据活动截止时间开奖）
活动奖品根据奖品名称排序1等2等三等...
谢谢参与奖品结果不排序
活动时间按运营设置结束时间为准
活动说明即抽奖说明
活动结束后不可参与并报错：“不好意思～抽奖已结束，如有疑问请联系上级”
- 抽奖结果
如诺中奖弹框抽奖结果与奖品名称
点击立即获取 如诺是商品则0元下单/是红包则根据该用户id指定发放给该用户钱包
          抽奖条件需登陆
          抽奖动画
          抽奖结果
          抽奖位6个
          抽奖记录登记抽奖结果与时间
          活动奖品根据奖品名称排序1等2等三等...
          谢谢参与奖品结果不排序
          活动时间按运营设置结束时间为准
          活动说明即抽奖说明
          活动结束后不可参与并报错：“不好意思～抽奖已结束，如有疑问请联系上级”
          抽奖结果
          如诺中奖弹框抽奖结果与奖品名称
          点击立即获取 如诺是商品则0元下单/是红包则根据该用户id指定发放给该用户钱包
-->

<template>
  <div class="lottery-table">
    <Top></Top>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import Bottom from "./components/Bottom";
  import Top from "./components/Top";
  export default {
    components: {
      Bottom,
      Top,
    },
  };
</script>

<style lang="less" scoped>
  @import "../var.less";
  // ---------------------------------
  .lottery-table {
    min-width: 376px;
    min-height: 667px;
    width: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    box-sizing: border-box;
    background: url("~@/assets/lottery/bg.jpg") no-repeat;
    background-size: 100% 100%;

    background-color: #ffffff;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #333;
    padding: 0;
    margin: auto 0;

    .bottom {
      position: relative;
      z-index: 99;
      width: 100%;
      height: 57%;
      background-color: #ffffff;
      margin-top: -130px;
      min-height: 440px;
      border-radius: 54px 54px 0 0;
      justify-content: space-evenly;
      bottom: 0;
    }
  }
</style>
